<script setup lang="ts">
import { GetAttributeOptionsResponseItem } from "@/models";
import { TirPmButton, TirPmButtonVariantEnum, TirPmInput } from "tir-components";
import { ArrowPathIcon, TrashIcon } from "tir-style-system/icons/outline";
import { onMounted, PropType, ref } from "vue";

/**Параметры */
const props = defineProps({
  /**индекс типа */
  index: { type: Number },
  /**Данные типов weeek */
  typesWeeek: { type: Array as PropType<GetAttributeOptionsResponseItem[]> },
  /**Тип weeek */
  typeDataWeeek: { type: Object as PropType<GetAttributeOptionsResponseItem> },
});

/**Удаление приоритета */
const removeTypesWeeek = (index: number) => {
  props.typesWeeek.splice(index, 1);
};
</script>
<template>
  <div class="weeek-types-item__block">
    <TirPmInput
      class="weeek-types-item__input"
      label="Тип с weeek.ru"
      :isWithHint="false"
      v-model="typeDataWeeek.WeeekValue"
    />
    <ArrowPathIcon class="weeek-types-item__icon" />
    <TirPmInput
      class="weeek-types-item__input"
      label="Тип на замену"
      :isWithHint="false"
      v-model="typeDataWeeek.PmValue"
    />
    <TirPmButton :variant="TirPmButtonVariantEnum.LinkState" @click="removeTypesWeeek(index)">
      <template #leftSlot>
        <TrashIcon class="weeek-types-item__icon-trash" />
      </template>
    </TirPmButton>
  </div>
</template>
<style scoped lang="scss">
.weeek-types-item {
  &__block {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  &__icon {
    min-width: 1.5rem;
    height: 1.5rem;
    color: var(--text-secondary, #686c73);
  }
  &__icon-trash {
    min-width: 1.5rem;
    height: 1.5rem;
  }
  &__input {
    width: 100%;
  }
}
</style>
